import { bffRequest } from "../../shared/api/bff-request";
import {
  ListResponse,
  PaginationRequestParams,
  SortingRequestParams,
} from "../../shared/types/api-types";

import {
  RentalDealDateFilter,
  RentalDealDecimalFilter,
  RentalDealItem,
  RentalDealListItem,
  RentalDealRateHistoryItem,
} from "./types";

export interface GetRentalDealsRequest {
  rentAreaIds?: string[];
  projectIds?: string[];
  areaSizeFilter?: RentalDealDecimalFilter;
  statusCode?: string;
  agreementNumber?: string;
  agreementStartDateFilter?: RentalDealDateFilter;
  agreementEndDateFilter?: RentalDealDateFilter;
  nextRateFilter?: RentalDealDecimalFilter;
  businessIds?: string[];
  businessCategoryIds?: number[];
  businessName?: string;
  currentRateFilter?: RentalDealDecimalFilter;
  nextRateDateFilter?: RentalDealDateFilter;
  isCommissionIncluded?: boolean;
  sorting?: SortingRequestParams<string>;
  pagination: PaginationRequestParams;
}

export const getRentalDeals = (body: GetRentalDealsRequest) =>
  bffRequest.post<ListResponse<RentalDealListItem>>("/rental-deals/list", body);

export const getRentalDeal = (rentAreaId: string) =>
  bffRequest.get<RentalDealItem | null>(
    `/rental-deals/item?rentAreaId=${encodeURIComponent(rentAreaId)}`,
  );

export interface GetRentalDealRatesRequest {
  rentAreaRentalDealId: string;
  sorting?: SortingRequestParams<string>;
  pagination: PaginationRequestParams;
}

export const getRentalDealRates = (body: GetRentalDealRatesRequest) =>
  bffRequest.post<ListResponse<RentalDealRateHistoryItem>>(
    "/rental-deals/rates",
    body,
  );

export interface GetRentalDealFileRequest {
  rentAreaRentalDealId: string;
  fileName: string;
}

export const getRentalDealFile = ({
  rentAreaRentalDealId,
  fileName,
}: GetRentalDealFileRequest) =>
  bffRequest.get<Blob>(
    `/rental-deals/file?rentAreaRentalDealId=${encodeURIComponent(
      rentAreaRentalDealId,
    )}&fileName=${encodeURIComponent(fileName)}`,
    { responseType: "blob" },
  );
